import Cookies from "js-cookie";
import { useLocation, Link } from "react-router-dom";
import { APP_DOMAIN, COOKIE_DOMAIN } from "../../config/env";
import ContentIcon from "../../assets/icons/content";
import DashboardIcon from "../../assets/icons/dashboard";
import FaqsIcon from "../../assets/icons/faqs";
import KeysIcon from "../../assets/icons/keys";
import ExitIcon from "../../assets/icons/exit";
import { useIsMobile } from "../../hooks/useIsMobile";

import "./AppSidebar.css";

export default function AppSidebar({
  isSidebarOpen,
}: {
  isSidebarOpen: boolean;
}) {
  const location = useLocation();
  const pathname = location.pathname;
  const isMobile = useIsMobile();

  const handleLogout = () => {
    Cookies.remove("access_token", { domain: COOKIE_DOMAIN });
    window.location.href = `${APP_DOMAIN}`;
  };

  return (
    <aside className={`app-sidebar ${isSidebarOpen ? "open" : ""}`}>
      <ul>
        <li className={pathname === "/" ? "active" : ""}>
          <Link to="/">
            <span>
              <DashboardIcon />
            </span>
            Dashboard
          </Link>
        </li>
        <li className={pathname === "/faqs" ? "active" : ""}>
          <Link to="/faqs">
            <span>
              <FaqsIcon />
            </span>
            Faqs
          </Link>
        </li>
        <li className={pathname === "/api-keys" ? "active" : ""}>
          <Link to="/api-keys">
            <span>
              <KeysIcon />
            </span>
            Api keys
          </Link>
        </li>
        <li className={pathname === "/manage-content" ? "active" : ""}>
          <Link to="/manage-content">
            <span>
              <ContentIcon />
            </span>
            Manage content
          </Link>
        </li>

        {isMobile && (
          <div className="app-sidebar-logout">
            <button
              className="app-sidebar-logout-button"
              type="button"
              aria-label="Log out"
              onClick={handleLogout}
            >
              <ExitIcon />
              Log out
            </button>
          </div>
        )}
      </ul>
    </aside>
  );
}
